<template>
  <div>
    <el-dialog :title="dialogTitle" :visible.sync="open" :center="true" width="80%" @close="cancel"
    :close-on-click-modal="false">
    <div class="edit-card">

      <el-row>
        <el-col :span="12">
          <div style="width: 100%; display: flex">
            <div class="start-label" />
            <span style="flex:6" class="text">待打包明细</span>
            <div >
              <el-button v-if="showBatchPackBtn()" style="margin:5px " class="btn primary" type="primary" size="small" v-preventReClick @click="batchPackEvt">批量打包</el-button>
              <el-button style="margin-top:5px" class="btn primary" type="primary" size="small" v-preventReClick @click="packEvt">打包</el-button>
            </div>

          </div>
          <el-table ref="toBePackagedDataRef" :data="toBePackagedData" border style="width: auto; margin: 10px 0px" height="300" row-key="id"
            :header-cell-style="{ background: '#DDEBFF' }" stripe @selection-change="handleSelectionChange" >
            <el-table-column v-if="showBatchPackBtn()" :key="'selection'" align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
            <el-table-column type="index" width="50" label="序号"> </el-table-column>
            <el-table-column prop="productName" label="产品" min-width="180"></el-table-column>
            <el-table-column prop="specName" label="规格型号" width="180"></el-table-column>
            <el-table-column prop="number" label="可打包数量" width="140"></el-table-column>
            <el-table-column  label="本次打包数量" width="180">
              <template slot-scope="scope">
                <el-input-number  size="small" v-model="scope.row.thisNumber" @change="(res)=>numberEvt(res,scope.row)" :min="0" :max="scope.row.number" label="请输入内容"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="manufacturerName" label="生产厂家" width="150"></el-table-column>
            <el-table-column prop="unit" label="最小单位" width="120"></el-table-column>
            <el-table-column prop="packSpec" label="包装规格" min-width="120"></el-table-column>
            <el-table-column prop="price" label="单价" width="180"></el-table-column>
            <el-table-column prop="batch" label="批次号" width="180"></el-table-column>
            <el-table-column prop="validityDate" label="有效期" width="180"></el-table-column>
            <el-table-column prop="serialNo" label="序列号" width="180"></el-table-column>
            <el-table-column prop="supplierName" label="供应商" width="180"></el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">打包预览</span>
          </div>
          <el-table :data="previewPackagedData" border style="width: auto; margin: 12px 0px" height="300"
            :header-cell-style="{ background: '#DDEBFF' }" stripe >
            <el-table-column type="index" width="50" label="序号"> </el-table-column>
            <el-table-column prop="productName" label="产品" min-width="180"></el-table-column>
            <el-table-column prop="specName" label="规格型号" width="180"></el-table-column>
            <el-table-column prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
            <el-table-column prop="number" label="本包数量" width="180"></el-table-column>
            <el-table-column prop="unit" label="最小单位" width="180"></el-table-column>
            <el-table-column prop="price" label="单价" width="180"></el-table-column>
            <el-table-column prop="batch" label="批次号" width="180"></el-table-column>
            <el-table-column prop="amount" label="金额小计" width="180"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <div class="edit-card">
      <el-row>
        <div style="width: 88%; display: flex">
          <div class="start-label" />
          <span class="text">已打包</span>
        </div>
        <el-table :data="packagedData" border style="width: auto; margin: 10px 0px" height="300"
          :header-cell-style="{ background: '#DDEBFF' }" stripe :span-method="objectSpanMethod">
          <el-table-column type="index" width="50" label="序号"> </el-table-column>
          <el-table-column prop="minTagCode" label="包标签码" min-width="200"></el-table-column>
          <el-table-column prop="productName" label="产品" min-width="180"></el-table-column>
          <el-table-column prop="specName" label="规格型号" width="180"></el-table-column>
          <el-table-column prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
          <el-table-column prop="number" label="数量" width="180"></el-table-column>
          <el-table-column prop="unit" label="最小单位" width="180"></el-table-column>
          <el-table-column prop="price" label="单价" width="180"></el-table-column>
          <el-table-column prop="batch" label="批次号" width="180"></el-table-column>
          <el-table-column prop="amount" label="小计" width="180"></el-table-column>
          <el-table-column prop="printTimes" label="打印次数" width="180"></el-table-column>
          <el-table-column fixed="right" prop="operation" label="操作" width="220">
            <template slot-scope="scope">
              <el-button type="text" size="small" v-preventReClick  @click="print(scope.row)" class="color-blue" >RFID打印</el-button>
              <el-button type="text" size="small" v-preventReClick @click="print1(scope.row)" class="color-blue" >普通打印</el-button>
              <el-button type="text" size="small" v-preventReClick @click="cancelCoed(scope.row)" class="color-blue" >作废</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </div>
  </el-dialog>
  <BatchPackDialog :open="batchPackDialog" :packagedData="packagedData1" @cancel="batchPackDialogClose" @confirm="batchPackDialogConfirm"/>

  </div>


</template>


<script>
import {
  GeneratePackTagCode,
  GetTagCodePrintData,
  CancelCode,
  GetTagCodeRfidPrintData
} from "@/api";
import BatchPackDialog from "@/components/batchPack-dialog";
// import GetDataMixin from "@/mixin/getData-mixin";
export default {
  components: {
    BatchPackDialog,
    },
  // mixins: [GetDataMixin],
  data () {
    return {
      dialogTitle: '动态打包赋码',
      // toBePackagedData:[],
      // packagedData:[],
      previewPackagedData: [],
      batchPackDialog: false,
      packagedData1:[],
      selection:[]
    }
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },

    toBePackagedData: {
      type: Array,
      default: () => {
        return []
      }
    },
    packagedData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  mounted () {
    this.rfidSocketApi.init(this.onmessage, this.onopen);
    this.$emit('getTableData', '');
  },
  beforeDestroy () {
    this.rfidSocketApi.clearBingMethods();
  },
  methods: {
    onmessage (e) {
      // window.console.log("收到消息啦:" + e.data);
      var data = JSON.parse(e.data);
      if (data.Successful) {
        this.$my_message("打印成功", "success");
      } else {
        this.$my_message("打印失败：" + data.Message, "error");
      }
    },
    onopen () {
      window.console.log("连接成功了哦");
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // If we are in the 'minTagCode' column
      if (columnIndex === 1||columnIndex==11) {
        // Check if it's the same as the previous row's 'minTagCode'
        if (rowIndex > 0 && this.packagedData[rowIndex].minTagCode === this.packagedData[rowIndex - 1].minTagCode) {
          
          // If so, hide the current cell
          return { rowspan: 0, colspan: 0 };
        } else {
          // Otherwise, keep the cell as normal
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.packagedData.length; i++) {
            if (this.packagedData[i].minTagCode === row.minTagCode) {
              rowspan++;
            } else {
              break;
            }
          }
          return { rowspan, colspan: 1 };
        }
      }
      return { rowspan: 1, colspan: 1 }; // Default behavior for other columns
    },
    numberEvt(res,row){     
        if((this.previewPackagedData.length === 0||this.previewPackagedData.filter(res=>res.id == row.id).length === 0) &&res!=0){
          let data = {...row,
            amount :res * row.price,
            number :res
          }
          this.previewPackagedData.push(data)
        } else{
        this.previewPackagedData.forEach((val,index)=>{
            if(val.id == row.id){
              if(res == 0||res==undefined){
                this.previewPackagedData.splice(index,1)
              }else{
                this.$set(val,'amount',res * val.price)
                this.$set(val,'number',res )
              }
            }
          });
        }
        this.$forceUpdate()
    },

    cancel () {
      this.$emit('close',false);
    },
    batchPackDialogConfirm(data){
      GeneratePackTagCode({tagCodeList:data}).then(res=>{
        this.$message.success('打包成功')
        this.$refs.toBePackagedDataRef.clearSelection()
        this.previewPackagedData = []
        this.batchPackDialogClose()
        this.$emit('getTableData', '');
      })
    },
    packEvt(){
      GeneratePackTagCode({tagCodeList:this.previewPackagedData}).then(res=>{
        this.$message.success('打包成功')
        this.$refs.toBePackagedDataRef.clearSelection()
        this.previewPackagedData = []
        this.$emit('getTableData', '');
      })
    },
       // 作废
      cancelCoed(row){
      this.$confirm('是否作废该标签？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CancelCode({minTagCode:row.minTagCode}).then(res=>{
          if(res.successful){
            this.$emit('getTableData', '');
            this.$message({
              type: 'success',
              message: '作废成功!'
            });
          }
    
        })
     
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消作废'
        });
      });
    },
      //普通打印
      print1 (row) {
      return new Promise((resolve, reject) => {
        let data = {
          tagCode: row.minTagCode,
          isSingle:row.isRfid==1?1:0
        }
        return GetTagCodePrintData(data).then((res) => {
          var result = res.returnData
          var printData = this.printDataConvert(result.printData)
          this.sendPrintMessage(JSON.stringify(printData));
          resolve(res.returnData);
        });
      });
    },
    print (row, notRefresh) {
      return new Promise((resolve, reject) => {
        return GetTagCodeRfidPrintData({
          tagCode: row.minTagCode,
        }).then((res) => {
          var action = "PrintSingle";
          if (row.isRfid != 1) {
            action = "PrintPack";
          }
            if(this.system_setting.RFIDTempSite){
            this.$my_message("打印成功", "success");
                resolve(res.returnData);
                return
            }
          var data = {
            Action: action,
            Content: res.returnData,
          };
          this.rfidSocketApi.sendSock(data);
          resolve(res.returnData);
        });
      });
    },
    showBatchPackBtn(){
      let isShowList = ['PurchaseDistributionEdit','ApplyOutStockEdit','PeriodEdit','StockUpCheckEdit']
      return isShowList.includes(this.$route.name)
    },
    batchPackEvt(){
      if(this.selection?.length == 0){
        this.$message.error('请勾选数据')
        return
      }
      this.packagedData1 = this.selection?.map(item=>{
        return{
          ...item,
          quantitySum:item.number,
        }
      })
      
      this.batchPackDialog = true

    },
    batchPackDialogClose(){
      this.packagedData1 = []
      this.batchPackDialog = false
    },
    handleSelectionChange(val) {
      this.selection = val;
    }
  }
}
</script>